import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useState,
} from "react";
import { RegistrationComponentProps } from "../../lib";
import countryCodes from "../../../../../src/backend/countryCodes.json";
import "./index.css";
import { useRegistrationSendOtpMutation } from "../../../../backend/app";
import Logo from "../../../../assets/logo.svg";

const cleanPhoneNumber = (number: string) => {
  return number.replace(/[\W_]+/g, "");
};

export const RegisterHandphone: FunctionComponent<RegistrationComponentProps> =
  ({ setNextIsDisabled, setRegistrationToken, onNextClickRef }) => {
    const MIN_PHONE_NUMBER_LENGTH = 7;
    const MAX_PHONE_NUMBER_LENGTH = 15;

    const countryCodeSelections = countryCodes.map((countryCode, index) => {
      return (
        <option key={`country-code-option-${index}`}>{countryCode.dial}</option>
      );
    });

    const [handphone, setHandphone] = useState<string>("");
    const [countryCodeSelection, setCountryCodeSelection] =
      useState<string>("+62");
    // const [businessCode, setBusinessCode] = useState<string>();

    const cleanHandphone = cleanPhoneNumber(handphone);
    const fullPhoneNumber = cleanPhoneNumber(
      countryCodeSelection + cleanHandphone,
    );

    const [sendOTP] = useRegistrationSendOtpMutation();

    useEffect(() => {
      setNextIsDisabled(
        !(
          fullPhoneNumber.length >= MIN_PHONE_NUMBER_LENGTH &&
          fullPhoneNumber.length <= MAX_PHONE_NUMBER_LENGTH
        ),
      );
    }, [fullPhoneNumber, setNextIsDisabled]);

    const submit = useCallback(async () => {
      const claim = await sendOTP({
        variables: {
          countryCode: parseInt(cleanPhoneNumber(countryCodeSelection)),
          phoneNumber: parseInt(cleanHandphone),
          token: "",
        },
        fetchPolicy: "no-cache",
      });
      setRegistrationToken(claim.data?.RegistrationSendOTP);
    }, [setRegistrationToken, sendOTP, countryCodeSelection, cleanHandphone]);

    onNextClickRef.current = useCallback(async () => {
      try {
        await submit();
      } catch (e) {
        throw e;
      }
    }, [submit]);

    return (
      <div className="hp">
        <div className="container logo">
          <img src={Logo} alt="gajiku-logo" />
          <div className="title">Gajiku</div>
        </div>
        <div className="header">
          <small>Halo! Harap masukan nomor Whatsapp.</small>
        </div>
        <div className="container hp-number">
          <small>Nomor Whatsapp</small>
          <div className="hp-field">
            <select onChange={(e) => setCountryCodeSelection(e.target.value)}>
              {countryCodeSelections}
            </select>
            <input
              value={handphone}
              onChange={(e) => setHandphone(e.target.value)}
              placeholder="Masuk Nomor Hp"
            />
          </div>
        </div>
      </div>
    );
  };
